import { DocumentTypeEnum} from '../enum/document-type.enum';
import { Choice } from '../models/choice';

export const DocumentTypes: Choice[] = [
    { value: DocumentTypeEnum.COMMERCIAL_INVOICE, label: $localize`Commercial Invoice` },
    { value: DocumentTypeEnum.DANGEROUS_GOODS_DECLARATION, label: $localize`Dangerous Goods Declaration` },
    { value: DocumentTypeEnum.CUSTOMER, label: $localize`Customer Attachment` },
    { value: DocumentTypeEnum.PROFORMA_INVOICE, label: $localize`Proforma Invoice` },
    { value: DocumentTypeEnum.CERTIFICATE_OF_ORIGIN, label: $localize`Certificate of Origin` },
    { value: DocumentTypeEnum.PRIOR_NOTICE, label: $localize`Prior Notice` }
];

export function getDocumentTypeLabel(type: string): string {
    const choice = DocumentTypes.find(c => c.value === type);
    return choice ? choice.label : type;
}
